export class Prefixer {
    constructor(prefix) {
        this.prefix = prefix;
    }
    create(value) {
        return `${this.prefix}-${value}`;
    }
}
//# sourceMappingURL=Prefixer.js.map